module.exports = __webpack_public_path__ + "static/media/weight-loss.b7455231.svg";